export const WIDGET_ACTIVE_VIEW_TRANSITION = 'WIDGET_ACTIVE_VIEW_TRANSITION';
export const REGISTER_VIEW_TRANSITION = 'REGISTER_VIEW_TRANSITION';
export const UNREGISTER_VIEW_TRANSITION = 'UNREGISTER_VIEW_TRANSITION';
